import Lightbox from './bs5-lightbox';
import Collapse from 'bootstrap/js/dist/collapse';

const options = {
    keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
    e.preventDefault();
    const lightbox = new Lightbox(el, options);
    lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    breakpoints: {
        992: {
            slidesPerView: 2,
            spaceBetween: 24
        }
    },
    autoHeight: true, // Make slides equal height
    autoplay: {
        delay: 10000,
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});
//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}
//
jQuery(document).ready(function ($) {
    // Handle anchor links on click
    $(document).on('click', 'a[href*="#"]', function (e) {
        var href = $(this).attr('href');
        var anchorMatch = href && href.match(/^[^#]*#(.+)/);
        if (anchorMatch) {
            e.preventDefault();
            var anchorId = anchorMatch[1];
            var targetElement = $('#' + anchorId);

            // Close mobile menu if open
            var navbarCollapse = $(this).closest('.navbar-collapse');
            if (navbarCollapse.length > 0 && navbarCollapse.hasClass('show')) {
                var bsCollapse = Collapse.getOrCreateInstance(navbarCollapse[0]);
                bsCollapse.hide();
            }

            // If target exists, smooth scroll; otherwise navigate
            if (targetElement.length > 0) {
                scrollToElement(targetElement);
            } else {
                // Store the anchor ID and navigate without the hash to avoid browser jump
                sessionStorage.setItem('scrollToAnchor', anchorId);
                window.location.href = href.split('#')[0];
            }
        }
    });

    // Handle anchors on page load
    var storedAnchor = sessionStorage.getItem('scrollToAnchor');
    if (storedAnchor) {
        sessionStorage.removeItem('scrollToAnchor');
        var targetElement = $('#' + storedAnchor);
        if (targetElement.length > 0) {
            // Wait longer to ensure header is fully rendered before calculating its height
            setTimeout(function () {
                scrollToElement(targetElement);
            }, 500);
        }
    }

    // Helper function to scroll smoothly to an element
    function scrollToElement(element) {
        var headerHeight = $('#wrapper-navbar').outerHeight() || 0;
        var linkOffset = element.offset().top - headerHeight;
        $('html, body').animate({
            scrollTop: linkOffset
        }, 'slow');
    }
});


//Animations
/*import ScrollOut from "scroll-out";
// Fade in Up
ScrollOut({
    targets: '.fadeInUp',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInUp', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInUp');
    },
    once: true
});

// Fade in Down
ScrollOut({
    targets: '.fadeInDown, .wp-block-button, h1, h2',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInDown', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInDown');
    },
    once: true
});*/
